export default __webpack_public_path__ + "static/media/fixed_balance_1.7072ae45.png";